"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressForm = exports.EDIT_ADDRESS_FORM_PATH = exports.ADD_ADDRESS_FORM_PATH = void 0;
require("../../../scss/addressForm.scss");
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const router_1 = require("@reach/router");
const react_i18next_1 = require("react-i18next");
const boutik_gatsby_plugin_components_1 = require("@sbi-international/boutik.gatsby.plugin.components");
const boutik_gatsby_plugin_multilocale_1 = require("@sbi-international/boutik.gatsby.plugin.multilocale");
const customerAccountContext_1 = require("../../../contexts/customerAccountContext");
const feedbackContext_1 = require("../../../contexts/feedbackContext");
const countriesRegionsHelper_1 = require("../../../helpers/countriesRegionsHelper");
const constants_1 = require("../../../constants");
const CustomerAccount_1 = require("../../CustomerAccount");
const Button_1 = require("../../common/Button");
const AddressBook_1 = require("./AddressBook");
exports.ADD_ADDRESS_FORM_PATH = "/add-address";
exports.EDIT_ADDRESS_FORM_PATH = "/edit-address";
const AddressForm = () => {
    var _a, _b, _c, _d;
    const { currentLocale, localizePath } = (0, boutik_gatsby_plugin_multilocale_1.usePageLocalization)();
    const location = (0, router_1.useLocation)();
    const searchParams = new URLSearchParams(location.search);
    const addressIdQueryParameter = searchParams.get("id");
    const defaultShippingQueryParameter = searchParams.get("ds");
    const defaultBillingQueryParameter = searchParams.get("db");
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    const customerAccountContext = (0, react_1.useContext)(customerAccountContext_1.CustomerAccountContext);
    const { countries } = customerAccountContext.actions.addresses.countryHook();
    const [initialAddress] = customerAccountContext.actions.addresses.addressByIdHook(Number(addressIdQueryParameter));
    const { addAlert } = (0, react_1.useContext)(feedbackContext_1.FeedbackContext);
    const useFormMethods = (0, react_hook_form_1.useForm)({
        mode: "onBlur",
        defaultValues: initialAddress
            ? {
                firstName: initialAddress.firstname,
                lastName: initialAddress.lastname,
                company: (_a = initialAddress.company) !== null && _a !== void 0 ? _a : "",
                telephone: initialAddress.telephone,
                isDefaultBilling: initialAddress.default_billing,
                isDefaultShipping: initialAddress.default_shipping,
                address: (_c = (_b = initialAddress.street) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : "",
                city: initialAddress.city,
                postalCode: initialAddress.postcode,
                countryId: initialAddress.country_code,
                regionId: (_d = initialAddress.region.region_id) !== null && _d !== void 0 ? _d : undefined,
                regionName: initialAddress.region.region_id ? undefined : initialAddress.region.region,
            }
            : {
                firstName: "",
                lastName: "",
                company: "",
                telephone: "",
                isDefaultBilling: defaultBillingQueryParameter === "1",
                isDefaultShipping: defaultShippingQueryParameter === "1",
                address: "",
                city: "",
                postalCode: "",
                countryId: currentLocale === "en_US" ? countriesRegionsHelper_1.UNITED_STATES_COUNTRY_ID : countriesRegionsHelper_1.CANADA_COUNTRY_ID,
                regionId: undefined,
                regionName: undefined,
            },
    });
    const watchCountryId = useFormMethods.watch("countryId");
    const isUpdateForm = (0, react_1.useMemo)(() => Boolean(initialAddress), [initialAddress]);
    const [formGlobalErrorMessage, setFormGlobalErrorMessage] = (0, react_1.useState)();
    const [canBeDefaultShippingAddress, setCanBeDefaultShippingAddress] = (0, react_1.useState)(false);
    const countriesSelect = (0, react_1.useMemo)(() => {
        return (0, countriesRegionsHelper_1.moveCanadaUsOnTop)(countries.map((country) => ({ value: country.id, label: country.full_name_locale })));
    }, [countries]);
    const regionsSelect = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        return ((_c = (_b = (_a = (0, countriesRegionsHelper_1.getCountryById)(countries, watchCountryId)) === null || _a === void 0 ? void 0 : _a.available_regions) === null || _b === void 0 ? void 0 : _b.map((region) => ({ value: region.id, label: region.name }))) !== null && _c !== void 0 ? _c : []);
    }, [watchCountryId]);
    const hasRegionSelectOptions = (0, react_1.useMemo)(() => regionsSelect.length > 0, [regionsSelect]);
    const firstRender = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        useFormMethods.setValue("regionId", undefined);
        useFormMethods.setValue("regionName", undefined);
    }, [watchCountryId]);
    (0, react_1.useEffect)(() => {
        const currentStoreCountryId = currentLocale === "en_US" ? countriesRegionsHelper_1.UNITED_STATES_COUNTRY_ID : countriesRegionsHelper_1.CANADA_COUNTRY_ID;
        if (currentStoreCountryId === watchCountryId) {
            setCanBeDefaultShippingAddress(true);
        }
        else {
            setCanBeDefaultShippingAddress(false);
            useFormMethods.setValue("isDefaultShipping", false);
        }
    }, [watchCountryId, currentLocale]);
    (0, react_1.useEffect)(() => {
        if (hasRegionSelectOptions) {
            useFormMethods.unregister("regionName");
        }
        else {
            useFormMethods.unregister("regionId");
        }
    }, [hasRegionSelectOptions]);
    const onSubmit = (formData) => {
        let regionToSubmit;
        if (formData.regionId) {
            const selectedCountry = (0, countriesRegionsHelper_1.getCountryById)(countries, formData.countryId);
            const selectedRegion = (0, countriesRegionsHelper_1.getRegionById)(selectedCountry, formData.regionId);
            regionToSubmit = {
                id: selectedRegion.id,
                code: selectedRegion.code,
                name: selectedRegion.name,
            };
        }
        else {
            regionToSubmit = {
                id: -1,
                code: "",
                name: formData.regionName,
            };
        }
        setFormGlobalErrorMessage(undefined);
        if (isUpdateForm) {
            return handleUpdateAddress({
                id: initialAddress.id,
                firstname: formData.firstName,
                lastname: formData.lastName,
                company: formData.company,
                telephone: formData.telephone,
                default_billing: formData.isDefaultBilling,
                default_shipping: formData.isDefaultShipping,
                street: [formData.address],
                city: formData.city,
                regionCode: regionToSubmit.code,
                regionId: regionToSubmit.id,
                regionName: regionToSubmit.name,
                countryCode: formData.countryId,
                postcode: formData.postalCode,
            });
        }
        else {
            return handleCreateAddress({
                firstname: formData.firstName,
                lastname: formData.lastName,
                company: formData.company,
                telephone: formData.telephone,
                default_billing: formData.isDefaultBilling,
                default_shipping: formData.isDefaultShipping,
                street: [formData.address],
                city: formData.city,
                regionCode: regionToSubmit.code,
                regionId: regionToSubmit.id,
                regionName: regionToSubmit.name,
                countryCode: formData.countryId,
                postcode: formData.postalCode,
            });
        }
    };
    const handleUpdateAddress = (updatedAddress) => {
        return customerAccountContext.actions.addresses
            .updateAddress(updatedAddress)
            .then(() => {
            addAlert({
                message: t("global.success.updateAddress"),
                status: "success",
            });
            navigateToAddressBook();
        })
            .catch((error) => {
            setFormGlobalErrorMessage(t(boutik_gatsby_plugin_components_1.FormInput.FormValidation.getMagentoErrorTranslationKey(currentLocale, error.message)));
        });
    };
    const handleCreateAddress = (newAddress) => {
        return customerAccountContext.actions.addresses
            .addAddress(newAddress)
            .then(() => {
            addAlert({
                message: t("global.success.addAddress"),
                status: "success",
            });
            navigateToAddressBook();
        })
            .catch((error) => {
            setFormGlobalErrorMessage(t(boutik_gatsby_plugin_components_1.FormInput.FormValidation.getMagentoErrorTranslationKey(currentLocale, error.message)));
        });
    };
    const navigateToAddressBook = () => {
        (0, router_1.navigate)(localizePath(CustomerAccount_1.CUSTOMER_ACCOUNT_PATH + AddressBook_1.ADDRESS_BOOK_PATH));
    };
    const isSelectedCountryUS = () => {
        return watchCountryId === "US";
    };
    return (react_1.default.createElement("div", { className: "boutik-customer-account-address-form-container" },
        react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, useFormMethods),
            react_1.default.createElement("h1", { className: "boutik-customer-account-address-form-title" }, isUpdateForm
                ? t("customerAccount.addressBook.addressForm.title.update")
                : t("customerAccount.addressBook.addressForm.title.add")),
            react_1.default.createElement("form", { className: "boutik-customer-account-address-form", onSubmit: useFormMethods.handleSubmit(onSubmit) },
                react_1.default.createElement("p", { className: "boutik-customer-account-address-form-global-error-message" }, formGlobalErrorMessage),
                react_1.default.createElement("div", { className: "boutik-customer-account-address-form-section-group" },
                    react_1.default.createElement("div", { className: "boutik-customer-account-address-form-section" },
                        react_1.default.createElement("h4", { className: "boutik-customer-account-address-form-section-contact-info-title" }, t("customerAccount.addressBook.addressForm.title.contactInfoSection")),
                        react_1.default.createElement(boutik_gatsby_plugin_components_1.FormInput.Text, { context: useFormMethods, classNamePrefix: "boutik-customer-account", property: "firstName", label: t("customerAccount.addressBook.addressForm.label.firstname"), required: true }),
                        react_1.default.createElement(boutik_gatsby_plugin_components_1.FormInput.Text, { context: useFormMethods, classNamePrefix: "boutik-customer-account", property: "lastName", label: t("customerAccount.addressBook.addressForm.label.lastname"), required: true }),
                        react_1.default.createElement(boutik_gatsby_plugin_components_1.FormInput.Text, { context: useFormMethods, classNamePrefix: "boutik-customer-account", property: "company", label: t("customerAccount.addressBook.addressForm.label.company") }),
                        react_1.default.createElement(boutik_gatsby_plugin_components_1.FormInput.Text, { context: useFormMethods, classNamePrefix: "boutik-customer-account", property: "telephone", validations: boutik_gatsby_plugin_components_1.FormInput.FormValidation.newPhoneNumberValidation(currentLocale), label: t("customerAccount.addressBook.addressForm.label.phoneNumber"), required: true }),
                        react_1.default.createElement("div", { className: "boutik-customer-account-form-checkbox-input-group" },
                            react_1.default.createElement("input", Object.assign({ className: "boutik-customer-account-form-checkbox-input", type: "checkbox" }, useFormMethods.register("isDefaultBilling"))),
                            react_1.default.createElement("label", { className: "boutik-customer-account-form-text-input-label boutik-customer-account-cacf-form-checkbox-label" }, t("customerAccount.addressBook.addressForm.label.defaultBilling"))),
                        react_1.default.createElement("div", { className: "boutik-customer-account-form-checkbox-input-group" },
                            react_1.default.createElement("input", Object.assign({ className: `boutik-customer-account-form-checkbox-input ${!canBeDefaultShippingAddress ? "boutik-customer-account-form-checkbox-input-disabled" : ""}`, type: "checkbox" }, useFormMethods.register("isDefaultShipping"), { disabled: !canBeDefaultShippingAddress })),
                            react_1.default.createElement("label", { className: "boutik-customer-account-form-text-input-label boutik-customer-account-cacf-form-checkbox-label" }, t("customerAccount.addressBook.addressForm.label.defaultShipping")))),
                    react_1.default.createElement("div", { className: "boutik-customer-account-address-form-section" },
                        react_1.default.createElement("h4", { className: "boutik-customer-account-address-form-section-address-title" }, t("customerAccount.addressBook.addressForm.title.addressSection")),
                        react_1.default.createElement(boutik_gatsby_plugin_components_1.FormInput.Text, { context: useFormMethods, classNamePrefix: "boutik-customer-account", property: "address", label: t("customerAccount.addressBook.addressForm.label.address"), required: true }),
                        react_1.default.createElement(boutik_gatsby_plugin_components_1.FormInput.Text, { context: useFormMethods, classNamePrefix: "boutik-customer-account", property: "city", label: t("customerAccount.addressBook.addressForm.label.city"), required: true }),
                        react_1.default.createElement("label", { className: "boutik-customer-account-address-form-select-input-label" },
                            t("customerAccount.addressBook.addressForm.label.country"),
                            react_1.default.createElement("span", { className: "boutik-customer-account-address-form-select-input-required" }, " *")),
                        react_1.default.createElement(boutik_gatsby_plugin_components_1.ReactSelect.ReactSelectUseFormWrapper, { control: useFormMethods.control, controlName: "countryId", rules: {
                                required: t("global.errors.required"),
                            }, reactSelectWrapperProps: {
                                placeholder: t("customerAccount.addressBook.addressForm.placeholder.countrySelect"),
                                noOptionsMessage: t("global.placeholder.reactSelectNoOptions"),
                                options: countriesSelect,
                                value: "",
                                errorMessage: {
                                    message: "",
                                    className: "boutik-customer-account-react-select-wrapper-error-message",
                                    position: "bottom",
                                },
                                styles: boutik_gatsby_plugin_components_1.ReactSelect.REACT_SELECT_WRAPPER_DEFAULT_STYLES,
                            } }),
                        hasRegionSelectOptions ? (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("label", { className: "boutik-customer-account-address-form-select-input-label" },
                                t(`customerAccount.addressBook.addressForm.label.${isSelectedCountryUS() ? "state" : "province"}`),
                                react_1.default.createElement("span", { className: "boutik-customer-account-address-form-select-input-required" }, " *")),
                            react_1.default.createElement(boutik_gatsby_plugin_components_1.ReactSelect.ReactSelectUseFormWrapper, { control: useFormMethods.control, controlName: "regionId", rules: {
                                    required: t("global.errors.required"),
                                }, reactSelectWrapperProps: {
                                    placeholder: t(`customerAccount.addressBook.addressForm.placeholder.${isSelectedCountryUS() ? "regionSelectState" : "regionSelectProvince"}`),
                                    noOptionsMessage: t("global.placeholder.reactSelectNoOptions"),
                                    options: regionsSelect,
                                    value: "",
                                    errorMessage: {
                                        message: "",
                                        className: "boutik-customer-account-react-select-wrapper-error-message",
                                        position: "bottom",
                                    },
                                    styles: boutik_gatsby_plugin_components_1.ReactSelect.REACT_SELECT_WRAPPER_DEFAULT_STYLES,
                                } }))) : (react_1.default.createElement(boutik_gatsby_plugin_components_1.FormInput.Text, { context: useFormMethods, classNamePrefix: "boutik-customer-account", property: "regionName", label: t(`customerAccount.addressBook.addressForm.label.${isSelectedCountryUS() ? "state" : "province"}`), required: true })),
                        react_1.default.createElement(boutik_gatsby_plugin_components_1.FormInput.Text, { context: useFormMethods, classNamePrefix: "boutik-customer-account", property: "postalCode", validations: boutik_gatsby_plugin_components_1.FormInput.FormValidation.newPostalOrZipCodeValidation(currentLocale, watchCountryId), label: t(`customerAccount.addressBook.addressForm.label.${isSelectedCountryUS() ? "zipCode" : "postalCode"}`), required: true }))),
                react_1.default.createElement(Button_1.Button, { isLoading: useFormMethods.formState.isSubmitting, isSubmitButton: true, label: "global.button.save", classNamePrefix: "boutik-customer-account-address-form-submit" })))));
};
exports.AddressForm = AddressForm;
//# sourceMappingURL=AddressForm.js.map